module.exports = __webpack_public_path__ + "img/code_default.9c45a84e.svg";